module.exports = __webpack_public_path__ + "img/Banner-Bonus-Komisi.48619e30.webp";